import apiClient from './client';
import { API_ENDPOINTS } from './config';
import type { IntegrationRecord, CreateIntegrationRequest } from '../types/integration';

export const integrationApi = {
	/**
	 * List all integrations for a location
	 */
	list: async (locationId: number): Promise<IntegrationRecord[]> => {
		return apiClient.get<IntegrationRecord[]>(
			`${API_ENDPOINTS.INTEGRATION.BASE}?locationId=${locationId}`
		);
	},

	/**
	 * Create a new integration (connect a platform)
	 */
	create: async (data: CreateIntegrationRequest): Promise<IntegrationRecord> => {
		return apiClient.post<IntegrationRecord>(API_ENDPOINTS.INTEGRATION.BASE, data);
	},

	/**
	 * Remove an integration by ID
	 */
	remove: async (id: number): Promise<void> => {
		return apiClient.delete(API_ENDPOINTS.INTEGRATION.DETAIL(id));
	},
};
